import React from 'react';

const ProgressStepper = ({ currentStep = 1 }) => {
  const steps = [
    { id: 1, icon: 'fa-satellite-dish', label: 'Scan Port', color: 'pink' },
    { id: 2, icon: 'fa-key', label: 'Crack Password', color: 'blue' },
    { id: 3, icon: 'fa-terminal', label: 'RCON Console', color: 'purple' },
  ];

  return (
    <div className="mb-8 transform-gpu transition-medium hover:scale-[1.01]">
      <div className="flex items-center justify-center">
        <div className="flex items-center relative">
          {steps.map((step, index) => (
            <React.Fragment key={step.id}>
              {/* Step */}
              <div className="flex flex-col items-center z-10 group">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${
                  currentStep >= step.id 
                    ? `bg-accent-${step.color} shadow-glow-${step.color}`
                    : 'bg-dark-400 text-gray-500'
                } ${
                  currentStep === step.id ? 'animate-pulse-slow' : ''
                }`}>
                  <i className={`fas ${step.icon} ${
                    currentStep >= step.id ? 'text-dark-800' : 'text-gray-400'
                  } transform-gpu group-hover:rotate-12 transition-medium`}></i>
                </div>
                <span className={`text-xs mt-2 font-medium transition-medium ${
                  currentStep >= step.id 
                    ? `text-accent-${step.color} group-hover:text-white` 
                    : 'text-gray-400'
                }`}>
                  {step.label}
                </span>
              </div>

              {/* Connector (except after last step) */}
              {index < steps.length - 1 && (
                <div className={`step-connector w-16 md:w-32 ${
                  currentStep > step.id ? 'active' : ''
                }`}></div>
              )}
            </React.Fragment>
          ))}
          
          {/* Animated background element */}
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-medium">
            <div className="w-full h-1 bg-gradient-to-r from-accent-pink/20 via-accent-blue/20 to-accent-purple/20 rounded-full blur-sm"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressStepper;